/*!
 * @author electricessence / https://github.com/electricessence/
 * Licensing: MIT
 */
define(["require", "exports", "../Environment"], function (require, exports, Environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Worker = Environment_1.isNodeJS ? require('./NodeJSWorker').default : self.Worker;
    exports.default = exports.Worker;
});
